// Quem abre o app quer ver o proprio nome, nao o endereco de e-mail. Durante o
// beta sao 5 contas criadas na mao pelo painel do Supabase, e o e-mail delas e
// comprido -- na tela de abertura ele quebra a linha e nao diz nada a ninguem.

interface UsuarioExibivel {
  email?: string | null
  user_metadata?: { nome?: unknown } | null
}

export function nomeDeExibicao(usuario: UsuarioExibivel | null | undefined): string {
  const nome = usuario?.user_metadata?.nome
  if (typeof nome === 'string' && nome.trim() !== '') return nome.trim()

  const email = usuario?.email
  if (typeof email !== 'string' || email.trim() === '') return ''
  // O comeco do e-mail: identifica a pessoa sem ocupar a linha inteira.
  return email.trim().split('@')[0]
}
